import { render, staticRenderFns } from "./MallRentDetailPage.vue?vue&type=template&id=2d592fe3&scoped=true"
import script from "./MallRentDetailPage.vue?vue&type=script&lang=js"
export * from "./MallRentDetailPage.vue?vue&type=script&lang=js"
import style0 from "./MallRentDetailPage.vue?vue&type=style&index=0&id=2d592fe3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d592fe3",
  null
  
)

export default component.exports